import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { genAjaxServiceGatewayConfig } from "./ajaxServiceGateway";
import { WEB2RAPI_SERVICE } from "./constants";

/**
 * Represents a fully processed Web2Rapi response. Right now
 * there is no standardized pattern for Web2Rapi reponses so it
 * is currently the same as a ProcessedAjaxServiceGatewayResponse
 */

export var genWeb2RapiConfig = function genWeb2RapiConfig(config) {
  return genAjaxServiceGatewayConfig(_objectSpread(_objectSpread({}, config), {}, {
    service: WEB2RAPI_SERVICE
  }));
};
//# sourceMappingURL=web2Rapi.js.map